import axios from '../axios/axios';
import {
  BENEFICIARY_DATA_REQUEST,
  BENEFICIARY_DATA_SUCCESS,
  BENEFICIARY_DATA_FAIL,
} from '../constants/beneficiaryConstants';

export const beneficiaryAction = () => async (dispatch) => {
  try {
    dispatch({ type: BENEFICIARY_DATA_REQUEST });
    const { data } = await axios.post('/rpiq-form-fetch', {
      section: 'f1v1s21',
      form_id: localStorage.getItem('formId'),
    });

    dispatch({
      type: BENEFICIARY_DATA_SUCCESS,
      payload: data,
    });
  } catch (error) {
    if (
      error?.response?.status === 401 ||
      error?.response?.detail === 'Not authenticated'
    ) {
      window.location.replace('/');
    }
    dispatch({
      type: BENEFICIARY_DATA_FAIL,
      payload: error,
    });
  }
};
